import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../css/RxartSecure/ParametersRS.module.css'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'primereact/tooltip'

export default function ParametersRS ({ parameters, setParameters, device }) {
  // console.log(device)
  const { t } = useTranslation('dashboardDevice')

  const items = [
    {
      label: t('modalRxartSecure.item6.label'),
      text: t('modalRxartSecure.item6.text'),
      inputName: 'advertensesDay',
      tooltipClass: 'message'
    },
    {
      label: t('modalRxartSecure.item5.label'),
      text: t('modalRxartSecure.item5.text'),
      inputName: 'maxUsesDay',
      tooltipClass: 'message'
    },
    {
      label: t('modalRxartSecure.item7.label'),
      text: t('modalRxartSecure.item7.text'),
      inputName: 'maxBoot',
      tooltipClass: 'message'
    },
    {
      label: t('modalRxartSecure.item8.label'),
      text: t('modalRxartSecure.item8.text'),
      inputName: 'checkInterval',
      tooltipClass: 'message'
    },
    {
      label: t('modalRxartSecure.item10.label'),
      text: t('modalRxartSecure.item10.text'),
      inputName: 'checkConfig',
      tooltipClass: 'message'
    },
    {
      label: t('modalRxartSecure.item9.label'),
      text: t('modalRxartSecure.item9.text'),
      inputName: 'restorePref',
      tooltipClass: ''
    }
  ]

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value)
    if (e.target.name !== 'restorePref') {
      setParameters({
        ...parameters,
        [e.target.name]: value
      })
    } else {
      setParameters({
        ...parameters,
        [e.target.name]: e.target.checked
      })
    }
  }

  return (
    <>
      <div className={styles.parametersContainer}>
        <Tooltip target=".message" />
        {items.map((element, index) => {
          const isEven = index % 2 === 0
          const input = element.inputName
          const validateInput = input === 'maxUsesDay' ? parameters?.maxUsesDay : input === 'advertensesDay' ? parameters?.advertensesDay : input === 'maxBoot' ? parameters?.maxBoot : input === 'checkInterval' ? parameters?.checkInterval : input === 'checkConfig' ? parameters?.checkConfig : parameters?.restorePref
          if (input !== 'restorePref') {
            return (
            <div key={element.inputName} className={`${styles.inputContainer} ${isEven ? styles.borderLeft : styles.borderRight}`}>
              <label className={styles.labelRS}>
                {element.label}
                <i
                  className={`pi pi-exclamation-circle message ${styles.iconMessage}`}
                  data-pr-tooltip={`${element.text}`}
                  data-pr-position="top"
                ></i>
              </label>
              <div>
                <input
                  className={styles.inputRS}
                  type="number"
                  name={element.inputName}
                  value={validateInput}
                  onChange={(e) => handleInputChange(e)}
                  min={1}
                  disabled={device?.device?.license === 'No disponible'}
                />
                <span className={styles.spanValue}>{input === 'maxBoot' ? t('modalRxartSecure.label76') : (input === 'checkInterval' || input === 'checkConfig') ? ' min.' : t('modalRxartSecure.label77')}</span>
              </div>
            </div>
            )
          } else {
            return (
              <></>
            )
          }
        })
        }
      </div>
      <div key='restorePref' className={styles.containerCheck} style={{ display: parameters?.id !== 1 ? 'display' : 'none' }}>
        <label className={styles.labelCheck}>
          <input
                value={parameters?.restorePref}
                name='restorePref'
                checked={parameters?.restorePref}
                onChange={(e) => handleInputChange(e)}
                type="checkbox"
                className={styles.check}
                disabled={device?.device?.license === 'No disponible'}
                />
          {t('modalRxartSecure.label78')}
        </label>
      </div>
    </>
  )
}

ParametersRS.propTypes = {
  parameters: PropTypes.object,
  setParameters: PropTypes.func,
  device: PropTypes.object
}
